import { initialSorting } from '@constants/tableSorting';

import { createStore } from '@store/createStore';

const useManageEquipmentStore = createStore(
  (set) => ({
    selectedRows: {},
    selectedAll: false,
    activeEquipment: [],
    inactiveEquipment: [],
    extraPanel: 'summary',
    equipmentSearch: '',
    sorting: { ...initialSorting },

    actions: {
      setEquipmentSelectedRows: (selectedRows) => set({ selectedRows }),
      setEquipmentSelectedAll: (selectedAll) => set({ selectedAll }),
      setActiveEquipment: (activeEquipment) => set({ activeEquipment }),
      setInactiveEquipment: (inactiveEquipment) => set({ inactiveEquipment }),
      setEquipmentExtraPanel: (extraPanel) => set({ extraPanel }),
      setEquipmentSearch: (equipmentSearch) => set({ equipmentSearch }),
      setSorting: (sorting) => set({ sorting }),
    },
  }),
  'ManageEquipmentStore',
);

export const useManageEquipmentActions = () => useManageEquipmentStore((state) => state.actions);

export const selectManageEquipmentSelectedRows = () => useManageEquipmentStore((state) => state.selectedRows);

export const selectManageEquipmentSelectedAllValue = () =>
  useManageEquipmentStore((state) => state.selectedAll);

export const selectManageEquipmentActiveEquipment = () =>
  useManageEquipmentStore((state) => state.activeEquipment);

export const selectManageEquipmentInactiveEquipment = () =>
  useManageEquipmentStore((state) => state.inactiveEquipment);

export const selectManageEquipmentExtraPanel = () => useManageEquipmentStore((state) => state.extraPanel);

export const selectManageEquipmentSearch = () => useManageEquipmentStore((state) => state.equipmentSearch);
export const selectManageEquipmentSorting = () => useManageEquipmentStore((state) => state.sorting);
